"use client";

import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import CustomButton from "./CustomButton";
import ScrollReveal from './ScrollReveal';
import { joinusCardData } from '@/data/data';
import Link from 'next/link';


export default function JoinUsSection() {
    return (
        <section className="relative w-full h-full pb-24 overflow-hidden bg-no-repeat" id='joinus'>
            <ScrollReveal  stagger={0.15}>
                <div className='wrapper grid lg:grid-cols-2 justify-center items-center gap-12'>
                    <img
                        src="/joinus1.webp"
                        alt="Join us Image"
                        className="w-full h-full object-cover pointer-events-none select-none rounded-2xl reveal-item"
                    />
                    <div className="col-span-1 flex flex-col justify-center">
                        <h2 className="text-3xl md:text-4xl text-yellow-500 font-bold mb-12 reveal-item">
                            Our Studio
                        </h2>
                        <p className="heading2 reveal-item">
                            Our team is talent dense with passionate people.
                            Everyone is heard and respected, and we encourage honest feedback
                            to help each other improve.
                        </p>

                    </div>
                </div>

                <div className="wrapper flex flex-col justify-center items-center text-center mt-20">
                    {/* Title */}
                    <h2 className="sectionTitle reveal-item">
                        Culture At Evonix
                    </h2>
                    <p className="heading2 max-w-3xl lg:text-center reveal-item">
                        Our studio is built on passion, creativity, and respect.
                        Here, every voice matters and honest feedback fuels our growth together.
                    </p>

                    {/* Features grid */}
                    <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
                        {joinusCardData.map((item, index) => (
                            <div
                                key={index}
                                className="group w-full relative bg-[#1A1A23]/80 backdrop-blur-sm rounded-2xl p-6 flex flex-col items-center text-center
                                shadow-lg hover:shadow-yellow-500/20 hover:-translate-y-2 transition-all duration-500 overflow-clip reveal-item"
                            >
                                {/* Flood Overlay Circles */}
                                <div className="absolute -top-1/2 -left-1/2 w-[200%] h-[200%] rounded-full bg-black/20 scale-0 group-hover:scale-100 transition-transform duration-1000 ease-out origin-top-left z-0" />
                                <div className="absolute -top-1/2 -left-1/2 w-[200%] h-[200%] rounded-full bg-black/20 scale-0 group-hover:scale-125 transition-transform duration-1000 ease-out origin-top-left z-0" />
                                
                                <div className="w-[200px] relative mb-4 z-10">
                                    <DotLottieReact
                                        src={item.img}
                                        loop
                                        autoplay
                                    />
                                </div>
                                <h3 className="text-xl font-semibold text-yellow-400 mb-2 z-10">
                                    {item.title}
                                </h3>
                                <p className="text-base leading-relaxed z-10">{item.desc}</p>
                            </div>
                        ))}
                    </div>

                    {/* CTA Button */}
                    <div className="mt-12 reveal-item">
                        <Link href="/career">
                            <CustomButton variant="primary" ariaLabel='Join The Team' title='Career Page'
                            >
                                Join The Team
                            </CustomButton>
                        </Link>
                    </div>

                </div>
            </ScrollReveal>
        </section>
    );
}
